module.exports = __webpack_public_path__ + "build/assets/latinmodern-math-e0188b701da62f7e462a2b75e3cbf7bb.woff2";